import { useCallback } from "react";
import { useListener } from "./useListener";

export function useWindowWidth(compute = (_width) => 0) {
  const listener = useCallback(() => compute(window.innerWidth), [compute]);
  return useListener('resize', listener);
}
